import script from "./ParamsSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./ParamsSettings.vue?vue&type=script&setup=true&lang=ts"

import "./ParamsSettings.vue?vue&type=style&index=0&id=33509406&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33509406"]])

export default __exports__